import { create, v, w } from '@dojo/framework/core/vdom';
import { childmap, keymap, pathmap, lccstate, userstate } from '@holmescorp/lcc-state';
import { TabContainer } from '@holmescorp/base-widgets';
import { TopicSetCards } from './topicset-cards';
import css from '../css/tabcontainer.m.css';
const factory = create({
    lccstate,
    userstate
});
export const DomainTabcontainer = factory(({ middleware: { lccstate, userstate } }) => {
    const { get, path } = lccstate;
    const roots = get(path('ditaroots'));
    const { get: uget, path: upath } = userstate;
    const qp = uget(upath('quizPattern'));
    const tablist = roots.map((root) => {
        const kidkeys = childmap.get(root) || [];
        const topic = {
            attributes: { key: `content-view` },
            children: kidkeys.map((tgf) => {
                const { path } = keymap.get(tgf);
                const { topic } = pathmap.get(path);
                return { ...topic };
            })
        };
        const { title: titleText = '' } = keymap.get(root) || {};
        const open = v('span', { xqa: `domain ${root}`, classes: [css.tabTitle, css.titleOpen] }, [titleText]);
        const closed = v('span', { xqa: `domain ${root}`, classes: [css.tabTitle, css.titleClosed] }, [titleText]);
        return {
            key: root,
            closeable: false,
            title: { open, closed },
            content: w(TopicSetCards, { path: qp, topic })
        };
    });
    return v('div', { id: `dashboard-${qp}`, xqa: `dashboard-tabcontainer-${qp}`, classes: [css.root] }, [
        w(TabContainer, {}, tablist)
    ]);
});
export default DomainTabcontainer;
